"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newSourceRule = newSourceRule;

var _utils = require("../../rule-editor/utils");

var _SourceRuleBook = _interopRequireDefault(require("./SourceRuleBook.json"));

var _sourceRuleProcessors = _interopRequireDefault(require("./source-rule-processors"));

function newSourceRule() {
  return [(0, _utils.newRule)({
    rule: _SourceRuleBook.default[_SourceRuleBook.default.entry],
    ruleBook: _SourceRuleBook.default,
    processors: _sourceRuleProcessors.default
  })];
}